export const BASE_URL = process.env.REACT_APP_BASE_URL;

const STATIC_ROUTES = {
  home: "/",
  test: "/test",
  city: "/:city",
  pin: "/:city/:pinID",
  not_found: "*",
  login: "/login",
  create_design: "/pin/:pinID/create-design",
  single_design: "/pin/:pinID/design/:designID",
  admin: "/admin",
  city_in_admin: "/admin/:city",
};

export default STATIC_ROUTES;
